import { render } from "./Timeline.vue?vue&type=template&id=fe4a2a2a&scoped=true"
import script from "./Timeline.vue?vue&type=script&setup=true&lang=js"
export * from "./Timeline.vue?vue&type=script&setup=true&lang=js"

import "./Timeline.vue?vue&type=style&index=0&id=fe4a2a2a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe4a2a2a"],['__file',"src/components/Paragraphs/Timeline.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fe4a2a2a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fe4a2a2a', __exports__)) {
    api.reload('fe4a2a2a', __exports__)
  }
  
  module.hot.accept("./Timeline.vue?vue&type=template&id=fe4a2a2a&scoped=true", () => {
    api.rerender('fe4a2a2a', render)
  })

}


export default __exports__